import { render } from "./SkillPage.vue?vue&type=template&id=5de2131f&scoped=true"
import script from "./SkillPage.vue?vue&type=script&lang=js"
export * from "./SkillPage.vue?vue&type=script&lang=js"

import "./SkillPage.vue?vue&type=style&index=0&id=5de2131f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de2131f"]])

export default __exports__